import { useState } from "react";
import { Box } from "@mui/material";

import Gatter from "../DetailGatter/Gatter";
import Line from "../DetailGatter/Line";
import Text from "../DetailGatter/Text";

export default function Tester() {
  const [inputA, setInputA] = useState(0);
  const [inputB, setInputB] = useState(0);
  const [carryIn, setCarryIn] = useState(0);

  const sum1 = inputA ^ inputB;
  const carry1 = inputA & inputB;

  const sumOut = sum1 ^ carryIn;
  const carry2 = sum1 & carryIn;

  const carryOut = carry1 || carry2;

  const toggle = (value, setter) => setter(value ? 0 : 1);

  return (
    <Box
      sx={{
        mt: 2,
        width: "95%",
        maxWidth: 700,
        mx: "auto",
      }}
    >
      <svg
        viewBox="0 0 700 220"
        height="100%"
        style={{ border: "1px solid #ccc" }}
      >
        {/* Inputs */}
        <Text x={20} y={30} text="Ü" color={carryIn} />
        <Line
          x1={60}
          x2={360}
          y={24}
          color={carryIn}
          position="start"
          handleClick={() => toggle(carryIn, setCarryIn)}
        />

        <Text x={20} y={70} text="A" color={inputA} />
        <Line
          x1={60}
          x2={200}
          y={63}
          color={inputA}
          position="start"
          handleClick={() => toggle(inputA, setInputA)}
        />

        <Text x={20} y={100} text="B" color={inputB} />
        <Line
          x1={60}
          x2={200}
          y={92}
          color={inputB}
          position="start"
          handleClick={() => toggle(inputB, setInputB)}
        />

        {/* Gates */}
        <Gatter x={200} y={45} text="XOR" />
        <Gatter x={360} y={10} text="XOR" />
        <Gatter x={200} y={140} text="AND" />
        <Gatter x={360} y={90} text="AND" />
        <Gatter x={500} y={110} text="OR" />

        {/* Connections */}
        <Line
          x1={170}
          x2={200}
          y={63}
          y2={165}
          color={inputA}
          position="angle"
        />
        <Line
          x1={150}
          x2={200}
          y={92}
          y2={185}
          color={inputB}
          position="angle"
        />

        <Line x1={300} x2={360} y={60} color={sum1} />
        <Line
          x1={340}
          x2={360}
          y={25}
          y2={110}
          color={carryIn}
          position="angle"
        />
        <Line x1={320} x2={360} y={60} y2={130} color={sum1} position="angle" />

        <Line x1={460} x2={640} y={40} color={sumOut} position="end" />
        <Text x={665} y={47} text="X" color={sumOut} />

        <Line x1={300} x2={500} y={160} color={carry1} />
        <Line x1={460} x2={500} y={130} color={carry2} />

        <Line x1={600} x2={640} y={130} color={carryOut} position="end" />
        <Text x={665} y={135} text="Ü" color={carryOut} />
      </svg>
    </Box>
  );
}
